import Popover from './Popover';

export type { PopoverProps } from './Popover';
export default Popover;
